import { render, staticRenderFns } from "./ProductVideo.vue?vue&type=template&id=f3082190&scoped=true"
import script from "./ProductVideo.vue?vue&type=script&lang=js"
export * from "./ProductVideo.vue?vue&type=script&lang=js"
import style0 from "./ProductVideo.vue?vue&type=style&index=0&id=f3082190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3082190",
  null
  
)

export default component.exports